import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const HomeIcon = ({ color = '#B5BCBD', size = 17, ...props }) => (
  <svg
    width={size}
    viewBox="0 0 23 22"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m21.724 9.569-.002-.002L12.747.594A2.012 2.012 0 0 0 11.315 0c-.541 0-1.05.21-1.433.593l-8.97 8.97-.009.009a2.028 2.028 0 0 0 .004 2.86 2.014 2.014 0 0 0 1.406.594h.358v6.604A2.373 2.373 0 0 0 5.041 22h3.512a.645.645 0 0 0 .645-.645v-5.177c0-.597.485-1.082 1.081-1.082h2.071c.597 0 1.082.485 1.082 1.082v5.177c0 .356.289.645.645.645h3.51a2.373 2.373 0 0 0 2.372-2.37v-6.604h.331a2.028 2.028 0 0 0 1.433-3.457Z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

HomeIcon.propTypes = propTypes;

export default HomeIcon;
